import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { TimezoneService } from '../services/timezone.service';

/**
 * Envía la zona horaria IANA del navegador en el header `X-Timezone`, que el API usa
 * para interpretar y devolver fechas. Si no se puede detectar, la petición sale sin el header.
 */
@Injectable()
export class TimezoneInterceptor implements HttpInterceptor {
  private timezoneService = inject(TimezoneService);

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    const timezone = this.timezoneService.getTimezoneHeader();

    if (!timezone) {
      return next.handle(req);
    }

    const timezoneReq = req.clone({
      setHeaders: {
        'X-Timezone': timezone,
      },
    });

    return next.handle(timezoneReq);
  }
}
